export default "__VITE_ASSET__D63$s9Dv__"